import { useReactFlow, useStore } from '@xyflow/react';
import { useEffect, useRef } from 'react';

import { ReadableViewportHelper } from './readable-viewport-helper';

function useViewportOnResize() {
  const rf = useReactFlow();
  const canvasWidth = useStore((s) => s.width);
  const canvasHeight = useStore((s) => s.height);
  const previousSize = useRef({ width: canvasWidth, height: canvasHeight });

  useEffect(() => {
    const previous = previousSize.current;
    const next = { width: canvasWidth, height: canvasHeight };
    previousSize.current = next;
    if (previous.width === 0 || previous.height === 0) return;
    if (previous.width === next.width && previous.height === next.height)
      return;
    rf.setViewport(
      ReadableViewportHelper.getViewportKeepingCentre(
        rf.getViewport(),
        previous,
        next
      )
    );
  }, [rf, canvasWidth, canvasHeight]);
}

export { useViewportOnResize };
